import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import AgencyConnectionsConfigurationContent from "./AgencyConnectionsConfigurationContent";
import {withRouterParams} from "../../utils/withRouterParams";
import {useUiVersion} from "../../context/UserModulesContext";
import {Spinner} from "../Spinner";
import {PlatformsV2} from "./connections_v2/PlatformsV2";

// Bifurcación UI v2 (tanda «Agencia 2.1», contrato §2): en la 2.1, Plataformas nueva; si no, el
// contenido de siempre, intacto. Espera a que la versión esté resuelta: un spinner, nunca un flash
// del clásico.
function PlatformsContent({agencyId, location, navigate}) {
    const {isV2, loaded} = useUiVersion();
    if (!loaded) {
        return (
            <div className="box-loader">
                <Spinner color="positive"/>
            </div>
        );
    }
    if (isV2) return <PlatformsV2 location={location} navigate={navigate}/>;
    return <AgencyConnectionsConfigurationContent agencyId={agencyId}/>;
}

class AgencyConnectionsConfiguration extends Component {
    getOnBoardingStatus() {
        if (this.props.location.state === undefined || this.props.location.state === null) {
            return false
        } else {
            return this.props.location.state.showOnBoarding
        }
    }

    render() {

        return (
            <div className="app-content">
                <LayoutSidebar showOnBoarding={this.getOnBoardingStatus()}/>
                <PlatformsContent agencyId={this.props.match.params.id} location={this.props.location}
                                  navigate={this.props.navigate}/>
            </div>
        )
    }
}

export default withRouterParams(AgencyConnectionsConfiguration);

